import Page from "../../components/Page";
import useOrganisationsList from "./hooks/useOrganisationsList";

const OrganisationsList = () => {
  const page = useOrganisationsList();
  return <Page {...page} />;
};

export default OrganisationsList;
